const WebFont = require('webfontloader')

WebFont.load({
  google: {
    families: ['Roboto:400,500'],
  },
  custom: {
    families: ['Butler', 'AvenirLT'],
    urls: ['/fonts/Butler/stylesheet.css', '/fonts/Avenir/stylesheet.css'],
  },
})
